import {
    ADDORUPDATEUSERWITHDRAWLIMIT_SUCCESS,
    ADDORUPDATEUSERWITHDRAWLIMIT_FAILED,
    RESET_ADDORUPDATEUSERWITHDRAWLIMIT,
    LOADING_ADDORUPDATEUSERWITHDRAWLIMIT,
    NETWORK_ERROR_ADDORUPDATEUSERWITHDRAWLIMIT,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetAddOrUpdateUserWithdrawLimit = () => {
    return { type: RESET_ADDORUPDATEUSERWITHDRAWLIMIT };
};

const addOrUpdateUserWithdrawLimit = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_ADDORUPDATEUSERWITHDRAWLIMIT });
    await partnerServices
        .post("addOrUpdateUserWithDrawLimit", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(addOrUpdateUserWithdrawLimitsuccess(res.data));
                    break;
                default:
                    dispatch(addOrUpdateUserWithdrawLimitFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: NETWORK_ERROR_ADDORUPDATEUSERWITHDRAWLIMIT, payload: err });
        });
};
function addOrUpdateUserWithdrawLimitsuccess(data) {
    return {
        type: ADDORUPDATEUSERWITHDRAWLIMIT_SUCCESS,
        payload: data,
    };
}
function addOrUpdateUserWithdrawLimitFailed(data) {
    return {
        type: ADDORUPDATEUSERWITHDRAWLIMIT_FAILED,
        payload: data,
    };
}

export { resetAddOrUpdateUserWithdrawLimit, addOrUpdateUserWithdrawLimit };
